import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { getRequiredConfig } from '../../lib/service-discovery';
import { useStream } from '@airia/ui';
import { useBrowserAgentVariables } from '../McpSessionProvider';
const ChatContext = createContext(undefined);
export const ChatProvider = ({ children, agentId, conversationId, }) => {
    const { user } = useAuth();
    const { apiUrl } = getRequiredConfig();
    const browserAgentVariables = useBrowserAgentVariables();
    const { submit, messages, isLoading } = useStream({
        apiUrl,
        agentId,
        conversationId,
        bearerToken: user?.access_token ?? '',
    });
    useEffect(() => {
        if (messages.length > 0) {
            messages.forEach((message) => {
                console.log('SSE message:', message);
            });
        }
    }, [messages]);
    const sendMessage = async (data) => {
        await submit({
            data: {
                ...data,
                variables: {
                    ...data.variables,
                    ...browserAgentVariables,
                },
            },
        });
    };
    const value = {
        messages,
        agentId,
        sendMessage,
        sendButtonDisabled: isLoading,
    };
    return _jsx(ChatContext.Provider, { value: value, children: children });
};
export function useChatContext() {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChatContext must be used within an ChatProvider');
    }
    return context;
}
